export default function useNcId(pre = "nc") {
  const id = Date.now().toString();
  return `${pre}_${id}`;
}
